import React, { useContext } from 'react';
import { TableContext } from './Table';

const TableData = ({ renderFormat, ...props }) => {
    const { tableData, currentPage, itemsPerPage, tableHeaders } = useContext(TableContext);

    const getPage = (page) => {
        page = (page - 1) * itemsPerPage;
        return tableData
            .slice(page, page + itemsPerPage)
            .map((e, i) => {
                const page = renderFormat(e, i, tableData)
                return page
            })
    }

    return tableData.length ? (
        <tbody>
            {getPage(currentPage).map(e => {
                const { children, ...props } = e.props;
            

                const temp = [children].flat().map((e, i) => {
                    const config = tableHeaders[i] ?? {}
                    return {
                        show: config.show ?? true,
                        order: config.order ?? i,
                        child: e,
                    }
                })

                const filteredChildren = temp
                    .filter((e) => e.show)
                    .sort((a, b) => a.order - b.order)
                    .map(e => e.child);

                return filteredChildren.length ? {
                    ...e,
                    props: { ...props, children: filteredChildren }
                } : null;
            })}
        </tbody>
    ) : null;
}

export default TableData;